export const homePartners = {
  title: '合作伙伴',
  en: 'Our Partners',
  subtitle:
    '华辉数智与县域政府、产业龙头、渠道网络及科研机构协同共建乡村数字经济生态，把可复用的产品与能力输送到更多县域与乡村场景。',
  groups: [
    {
      icon: 'ri-government-line',
      name: '县域政府与平台公司',
      desc: '县域数字商业基础设施共建与运营',
    },
    {
      icon: 'ri-store-3-line',
      name: '渠道与门店网络',
      desc: '数字货架、云铺与终端门店网络协同',
    },
    {
      icon: 'ri-truck-line',
      name: '产业与供应链伙伴',
      desc: '农产品上行、仓配与流通协同',
    },
    {
      icon: 'ri-flask-line',
      name: '技术与科研机构',
      desc: 'AIoT 与数字身份技术联合研发',
    },
  ],
};